import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from '../../../../axiosConfig';
import styles from '../../MicroProbe//MicroProbe.module.css';
import ChatNumbers from './ChatNumbers';
import PriceData from './PriceData';
import PriceDataIntraday from './PriceDataIntraday';
import PerformanceOverview from './PerformanceOverview';



const IndividualCryptoNumbers = () => {
  const { cryptoName } = useParams();
  const [inputData, setInputData] = useState(null);
  
  useEffect(() => {
    const fetchInputData = async () => {
      try {
        const response = await axios.get(`/api/crypto/name/${cryptoName}`);
        setInputData(response.data);

      } catch (error) {
        console.error('Error fetching currency data:', error);
      }
    };
  
    fetchInputData();
  }, [cryptoName]);


return (
  <div className={styles.container}>
    <h1 className={styles.title}>Cryptocurrency: {cryptoName }</h1>

    {inputData && (
      <>  
  
        <div className={`${styles.section} ${styles.sectionQuarter}`}>
        <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
            <PerformanceOverview  inputData={inputData} />
          </div>

          <div className={styles.divider}></div>
          <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
            <PriceDataIntraday inputData={inputData} />
          </div>
          <div className={styles.dividernone}></div>

        
          <div className={styles.divider}></div>
          <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
            <PriceData inputData={inputData} />
          </div>
          <div className={styles.dividernone}></div>

          <div className={styles.sectionContent} style={{ width: '100%', height: 'auto' }}>
            <ChatNumbers inputData={inputData} />
          </div>
          <div className={styles.dividernone}></div>
          

        </div>


      </>
    )}

    
    <div style={{ marginTop: '20px' }}>
        <Link to="/historical-analysis">Back</Link>
      </div> 

  </div>
);
};

export default IndividualCryptoNumbers;